import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { Dropdown } from "primereact/dropdown";
import { getDataConfiguracion,getListaUsuarios, crearUsuario, editarUsuario, deleteUsuario, deleteUsuarioMasivo } from "../../service/Usuario";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../actions";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import classNames from "classnames";
import { getListaPerfil } from "../../service/Perfil";
import { isNotVacioNull, isEmail, isRun, isLetras, isLetrasEspacio, minMax, isValue, isTelefono, getResultValidar } from "../../utilities/Validate";
import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../utilities/Seguridad";
import { Badge } from "primereact/badge";
import ApiFunctions from '../../service/Api'

export const PageUsuario = () => {
    const dispatch = useDispatch();
    const { POST, GET, PUT, DELETE } = ApiFunctions();
    const labelDialog = useRef({ title: "", labelButton: "", editAcceso: {}, visible: false, es_nuevo: false });

    let claseUsuario = {
        id: null,
        email: "",
        password: "",
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        estado: "",
        rol: "",
        cargo: ''
    };

    let claseUsuarioValidate = {
        id: { estado: null, mensaje: "", validar: isValue, minmax: false },
        email: { estado: true, mensaje: "Error formato email con longitud max. 45", validar: isEmail, minmax: true, min: 1, max: 45 },
        nombres: { estado: true, mensaje: "Valor requerido letras con longitud min 3, max. 45", validar: isLetras, minmax: true, min: 3, max: 45 },
        apellido_paterno: { estado: true, mensaje: "Valor requerido letras con longitud min 3, max. 45", validar: isLetras, minmax: true, min: 3, max: 45 },
        apellido_materno: { estado: true, mensaje: "Valor requerido letras con longitud min 3, max. 45", validar: isLetras, minmax: true, min: 3, max: 45 },
        estado: { estado: null, mensaje: "", validar: isValue, minmax: false },
        rol: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        cargo: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
    };

    const [globalFilter, setGlobalFilter] = useState("");
    const [visibleDialog, setVisibleDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const toast = useRef(null);

    const [tablaData, setTablaData] = useState(claseUsuario);
    const [usuarioData, setUsuarioData] = useState(claseUsuario);
    const [usuarioDataValidate, setUsurioDataValidate] = useState(claseUsuarioValidate);
    const [roles, setRoles] = useState({});
    const [selectRow, setSelectRow] = useState(null);
    const [countDelete, setCountDelete] = useState(0);
    const [cargos, setCargos] = useState([]);

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.seguridad.usuarios.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    const loadListaPerfil = async () => {

        if (colegio.id !== undefined) {
            let rolesData = await getListaPerfil(usuario.token, colegio.id);
            setRoles(rolesData.roles);
            let data = await getDataConfiguracion('cargos', usuario.token);
            if (data.error == 0) {
                setCargos(data.cargos);
            } else {
                console.log(data.mensaje);
            }
        }
    };

    useEffect(() => {
        if (accionPermiso(permisos, "usuario_ver")) {
            loadListaPerfil();
            loadListaUsuario();
        } else {
            history.push("/Acceso");
        }
    }, [anio]);

    const loadListaUsuario = async () => {
        if (colegio.id !== undefined) {
            dispatch(loading(true));
            //var data = await getListaUsuarios(colegio.id, usuario.token);
            let data = await GET('usuario', 'listar', [ colegio.id]);
            if (data.error == 0) {
                setTablaData(data.data);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        }
        setCountDelete(0);
        setSelectRow(null);
    };

    const saveUsuario = async () => {
        setSubmitted(true);
        if (colegio.id !== undefined) {
            usuarioDataValidate["password"] = { estado: true, mensaje: "Valor requerido letras con longitud min 3, max. 45", validar: labelDialog.current.es_nuevo ? isNotVacioNull : isValue, minmax: true, min: 3, max: 45 };

            let validado = getResultValidar(usuarioData, usuarioDataValidate);

            setUsurioDataValidate(validado.result);

            if (validado.registra) {
                dispatch(loading(true));
                var data = null;

                if (labelDialog.current.es_nuevo) {
                    data = await crearUsuario(usuarioData, colegio.id, usuario.token);
                } else {
                    data = await editarUsuario(usuarioData, colegio.id, usuario.token);
                }

                if (data.error == 0) {
                    hideDialog();
                    loadListaUsuario();
                    toast.current.show({ severity: "success", summary: "OK", detail: "Registros guardados!", life: 3000 });
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                    } else {
                        console.log("Error");
                    }
                }
                dispatch(loading(false));
            }
        }
    };

    const viewNuevoPerfilAcceso = () => {
        setVisibleDialog(true);
        labelDialog.current.title = "Nuevo Usuario";
        labelDialog.current.labelButton = "Registrar";
        labelDialog.current.es_nuevo = true;
        setUsuarioData(claseUsuario);
    };

    const viewDetalle = (row) => {
        labelDialog.current.visible = true;
        labelDialog.current.title = "Actualizar Usuario";
        labelDialog.current.labelButton = "Actualizar";
        labelDialog.current.es_nuevo = false;
        let dataEdit = { ...claseUsuario };
        dataEdit.id = row.id;
        dataEdit.email = row.email == null ? "" : row.email;
        dataEdit.nombres = row.nombres == null ? "" : row.nombres;
        dataEdit.apellido_paterno = row.apellido_paterno == null ? "" : row.apellido_paterno;
        dataEdit.apellido_materno = row.apellido_paterno == null ? "" : row.apellido_materno;

        dataEdit.rol = roles.find((o) => o.id === row.idrol);
        dataEdit.cargo = cargos.find((o) => o.id === row.idcargo);

        //dataEdit.colegio = arrayColegio.find(o => o.id === row.idcolegio);
        dataEdit.estado = row.estado == 1 ? true : false;
        setVisibleDialog(true);
        setUsuarioData(dataEdit);
    };

    const hideDialog = () => {
        setVisibleDialog(false);
        labelDialog.current.visible = false;
        setSubmitted(false);
        //setDataMatricula(null);
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _detalla = { ...usuarioData };
        _detalla[`${name}`] = val;
        setUsuarioData(_detalla);
    };

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const bodyTemplateActivo = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                <Tag className="p-mr-2" severity={data[props.field] == 1 ? "success" : "warning"} value={data[props.field] == 1 ? "ACTIVO" : "INACTIVO"}></Tag>
            </>
        );
    };

    const statusBodyTemplate = (rowData) => {
        if (rowData.adicional === 1) {
            return <Tag className="mr-2" severity="info" value="ADICIONAL"></Tag>;
        }
    };

    const statusBodyTemplateObservacion = (rowData) => {
        return <Button icon="pi pi-info-circle" className="p-button-rounded p-button-info" tooltip={rowData.observacion} tooltipOptions={{ position: "bottom" }}></Button>;
        //return <InputText type="text" placeholder="Left" tooltip={rowData.observacion} tooltipOptions={{position: 'bottom'}} />
    };

    const confirmDeleteProduct = (row) => {
        //setProduct(product);
        //setDeleteProductDialog(true);
    };

    const rowUsuario = useRef(null);

    const accept = async () => {
        let data = await deleteUsuario(rowUsuario.current, usuario.token);

        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminó el usuario", life: 3000 });
            loadListaUsuario();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
    };

    const eliminarMasivo = async () => {
        let arrayIds = selectRow.map(function (item) {
            return item.id;
        });

        dispatch(loading(true));
        let data = await deleteUsuarioMasivo(arrayIds, usuario.token);
        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminaron los registros", life: 3000 });
            loadListaUsuario();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    };

    const confirmDeleteMasivo = () => {
        confirmDialog({
            message: "Estas seguro de eliminar los usuarios seleccionados?",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: () => eliminarMasivo(),
        });
    };

    const confirmDelete = (row) => {
        rowUsuario.current = row.id;
        confirmDialog({
            message: "Estas seguro de eliminar al usuario?",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept,
        });
    };

    const actionBodyDelete = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDelete(rowData)} />
            </div>
        );
    };

    const dataTableHeader = (
        <div className="table-header">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>

            <div className="flex align-items-center export-buttons">
                {accionPermiso(permisos, "usuario_eliminar_masivo") && countDelete > 0 ? (
                    <i className="pi pi-trash mr-4 p-text-secondary p-overlay-badge" style={{ fontSize: "2rem", marginRight: "1.5rem", cursor: "pointer" }} onClick={() => confirmDeleteMasivo(null)}>
                        <Badge value={countDelete} severity="danger"></Badge>
                    </i>
                ) : (
                    ""
                )}
                {accionPermiso(permisos, "usuario_crear") ? <Button type="button" icon="pi pi-plus" label="Usuario" className="mr-2 p-mr-1" onClick={viewNuevoPerfilAcceso} tooltip="Nuevo Usuario" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button> : ""}
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadListaUsuario} tooltip="Actualizar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
            </div>
        </div>
    );

    const actionHerramienta = (rowData) => {
        return <div className="actions">
            {accionPermiso(permisos, "usuario_editar") ? (
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => viewDetalle(rowData)} />

            ) : (
                ""
            )}
            {accionPermiso(permisos, "usuario_eliminar") && countDelete < 1 ? <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDelete(rowData)} /> : ""}
        </div>
    };

    const dialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={labelDialog.current.labelButton} icon="pi pi-check" onClick={saveUsuario} />
        </>
    );

    const checkRows = (value) => {
        if (!accionPermiso(permisos, "usuario_eliminar_masivo")) return true;
        setSelectRow(value);
        setCountDelete(value.length);
    };

    return (
        <div className="p-grid table-demo">
            <div className="p-col-12">
                <Toast ref={toast} />

                <DataTable
                    value={tablaData}
                    selectionMode="checkbox"
                    paginator
                    id="13"
                    selection={selectRow}
                    onSelectionChange={(e) => checkRows(e.value)}
                    className="p-datatable-customers p-datatable-sm"
                    rows={10}
                    dataKey="id"
                    rowHover
                    globalFilter={globalFilter}
                    emptyMessage="No existe información!"
                    loading={false}
                    header={dataTableHeader}
                    metaKeySelection={true}
                    size="small"
                >
                    {accionPermiso(permisos, "usuario_eliminar_masivo") ? <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column> : <Column headerStyle={{ width: "0em" }}></Column>}
                    <Column field="email" header="Email" sortable body={bodyTemplate}></Column>
                    <Column field="nombres" header="Nombres" sortable body={bodyTemplate}></Column>
                    <Column field="apellido_paterno" header="Paterno" sortable body={bodyTemplate}></Column>
                    <Column field="apellido_materno" header="Materno" sortable body={bodyTemplate}></Column>
                    <Column field="rol" header="Rol" sortable body={bodyTemplate}></Column>
                    <Column field="cargo" header="Cargo" sortable body={bodyTemplate}></Column>
                    <Column field="estado" header="Estado" sortable body={bodyTemplateActivo}></Column>
                    <Column headerStyle={{ width: "8rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionHerramienta}></Column>
                </DataTable>

                <Dialog visible={visibleDialog} style={{ width: "40vw" }} breakpoints={{ "960px": "100vw" }} header={labelDialog.current.title} modal className="p-fluid" footer={dialogFooter} onHide={hideDialog}>
                    <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-0">
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Email</label>
                            <InputText value={usuarioData.email} onChange={(e) => onInputChange(e, "email")} required className={classNames({ "p-invalid": submitted && !usuarioDataValidate.email.estado })} />
                            {submitted && !usuarioDataValidate.email.estado && <small className="p-error">{usuarioDataValidate.email.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Contraseña</label>
                            <InputText type="password" value={usuarioData.password} onChange={(e) => onInputChange(e, "password")} required className={classNames({ "p-invalid": submitted && !usuarioDataValidate.password.estado })} />
                            {submitted && !usuarioDataValidate.password.estado && <small className="p-error">{usuarioDataValidate.password.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Nombres</label>
                            <InputText value={usuarioData.nombres} onChange={(e) => onInputChange(e, "nombres")} required className={classNames({ "p-invalid": submitted && !usuarioDataValidate.nombres.estado })} />
                            {submitted && !usuarioDataValidate.nombres.estado && <small className="p-error">{usuarioDataValidate.nombres.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Paterno</label>
                            <InputText value={usuarioData.apellido_paterno} onChange={(e) => onInputChange(e, "apellido_paterno")} required className={classNames({ "p-invalid": submitted && !usuarioDataValidate.apellido_paterno.estado })} />
                            {submitted && !usuarioDataValidate.apellido_paterno.estado && <small className="p-error">{usuarioDataValidate.apellido_paterno.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Materno</label>
                            <InputText value={usuarioData.apellido_materno} onChange={(e) => onInputChange(e, "apellido_materno")} required className={classNames({ "p-invalid": submitted && !usuarioDataValidate.apellido_materno.estado })} />
                            {submitted && !usuarioDataValidate.apellido_materno.estado && <small className="p-error">{usuarioDataValidate.apellido_materno.mensaje}</small>}
                        </div>
                        {/*  <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
              <label htmlFor="name2">Colegio</label>
              <Dropdown value={usuarioData.colegio} onChange={(e) => onInputChange(e, 'colegio')} options={arrayColegio} optionLabel="nombre" placeholder="--" />
              {submitted && !usuarioDataValidate.colegio.estado && <small className="p-error">{usuarioDataValidate.colegio.mensaje}</small>}
           </div> */}
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Colegio</label>
                            <InputText value={colegio.nombre} disabled />
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Rol</label>
                            <Dropdown value={usuarioData.rol} onChange={(e) => onInputChange(e, "rol")} options={roles} optionLabel="rol" placeholder="--" />
                            {submitted && !usuarioDataValidate.rol.estado && <small className="p-error">{usuarioDataValidate.rol.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">CARGO</label>
                            <Dropdown value={usuarioData.cargo} options={cargos} onChange={(e) => onInputChange(e, 'cargo')} optionLabel="cargo" filter showClear filterBy="cargo" placeholder="Seleccionar..." />
                            {submitted && !usuarioDataValidate.cargo.estado && <small className="p-error">{usuarioDataValidate.cargo.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Estado</label>
                            <div className="p-field-radiobutton p-mt-2 p-mb-1">
                                <InputSwitch checked={usuarioData.estado} onChange={(e) => onInputChange(e, "estado")} />
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    );
};
